(() => {
  const initializeFokusProducts = () => {
    const products = document.querySelectorAll(
      '.fokus-pdp:not([data-fokus-ready])'
    );

    products.forEach((root) => {
      root.dataset.fokusReady = 'true';

      const form = root.querySelector(
        '.fokus-pdp__form'
      );

      const primaryButton = root.querySelector(
        '[data-fokus-primary-atc]'
      );

      const primaryLabel = root.querySelector(
        '[data-fokus-atc-label]'
      );

      const stickyBar = root.querySelector(
        '[data-fokus-sticky-atc]'
      );

      const stickyButton = root.querySelector(
        '[data-fokus-sticky-button]'
      );

      const stickyLabel = root.querySelector(
        '[data-fokus-sticky-label]'
      );

      const stickySummary = root.querySelector(
        '[data-fokus-sticky-summary]'
      );

      const price = root.querySelector(
        '[data-fokus-price]'
      );

      const stickyPrice = root.querySelector(
        '[data-fokus-sticky-price]'
      );

      const variantSelect = root.querySelector(
        '[data-fokus-variant-select]'
      );

      const quantityContainer = root.querySelector(
        '.fokus-pdp__quantity'
      );

      const quantityInput = root.querySelector(
        '[data-fokus-quantity-input]'
      );

      const quantityMinus = root.querySelector(
        '[data-fokus-quantity-minus]'
      );

      const quantityPlus = root.querySelector(
        '[data-fokus-quantity-plus]'
      );

      const buyRow = root.querySelector(
        '.fokus-pdp__buy-row'
      );

      const purchaseTypeInputs = Array.from(
        root.querySelectorAll(
          'input[name="fokus_purchase_type"]'
        )
      );

      const error = root.querySelector(
        '[data-fokus-form-error]'
      );

      const track = root.querySelector(
        '[data-fokus-media-track]'
      );

      const media = Array.from(
        root.querySelectorAll(
          '[data-fokus-media]'
        )
      );

      const dots = Array.from(
        root.querySelectorAll(
          '[data-fokus-media-dot]'
        )
      );

      const getPurchaseType = () => {
        const selectedInput =
          purchaseTypeInputs.find(
            (input) => input.checked
          );

        return (
          selectedInput?.value ||
          'one-time'
        );
      };

      const getSelectedPurchaseInput = () => {
        return purchaseTypeInputs.find(
          (input) => input.checked
        );
      };

      const getSelectedPurchasePrice = () => {
        const selectedInput =
          getSelectedPurchaseInput();

        if (!selectedInput) {
          return '';
        }

        const explicitPrice =
          selectedInput.dataset.price ||
          selectedInput.dataset.formattedPrice ||
          selectedInput.dataset.money ||
          '';

        if (explicitPrice) {
          return explicitPrice;
        }

        const associatedLabel =
          selectedInput.id
            ? root.querySelector(
                `label[for="${CSS.escape(
                  selectedInput.id
                )}"]`
              )
            : null;

        const optionContainer =
          selectedInput.closest('label') ||
          associatedLabel ||
          selectedInput.parentElement;

        const priceMatches =
          optionContainer
            ?.textContent
            ?.match(
              /[$€£]\s?\d+(?:[.,]\d{2})?/g
            );

        return priceMatches?.at(-1) || '';
      };

      const isSubscriptionSelected = () => {
        return (
          getPurchaseType() ===
          'subscription'
        );
      };

      const getQuantityLimits = () => {
        const minimum = Math.max(
          1,
          Number(quantityInput?.min || 1)
        );

        const maximum = Math.max(
          minimum,
          Number(quantityInput?.max || 10)
        );

        return {
          minimum,
          maximum
        };
      };

      const sanitizeQuantity = (value) => {
        const {
          minimum,
          maximum
        } = getQuantityLimits();

        const parsedValue =
          Number.parseInt(
            value,
            10
          );

        if (
          !Number.isFinite(parsedValue)
        ) {
          return minimum;
        }

        return Math.min(
          maximum,
          Math.max(
            minimum,
            parsedValue
          )
        );
      };

      const getQuantity = () => {
        if (
          isSubscriptionSelected()
        ) {
          return 1;
        }

        return sanitizeQuantity(
          quantityInput?.value || 1
        );
      };

      const updateQuantity = (
        value,
        dispatchChange = true
      ) => {
        if (!quantityInput) return;

        const newQuantity =
          isSubscriptionSelected()
            ? 1
            : sanitizeQuantity(value);

        quantityInput.value =
          String(newQuantity);

        if (dispatchChange) {
          quantityInput.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }

        synchronizeStickySummary();
      };

      const synchronizeQuantityButtons = () => {
        if (!quantityInput) return;

        const quantity =
          getQuantity();

        const {
          minimum,
          maximum
        } = getQuantityLimits();

        if (quantityMinus) {
          quantityMinus.disabled =
            quantity <= minimum;
        }

        if (quantityPlus) {
          quantityPlus.disabled =
            quantity >= maximum;
        }
      };

      const synchronizeStickySummary = () => {
        if (!stickySummary) return;

        const baseTitle =
          stickySummary.dataset
            .baseTitle ||
          stickySummary.textContent.trim();

        stickySummary.dataset.baseTitle =
          baseTitle;

        const quantity =
          getQuantity();

        if (isSubscriptionSelected()) {
          stickySummary.textContent =
            'Subscribe & save 20%';
        } else {
          stickySummary.textContent =
            quantity > 1
              ? `${baseTitle} × ${quantity}`
              : baseTitle;
        }

        synchronizeQuantityButtons();
      };

      const synchronizePurchaseType = () => {
        const subscriptionSelected =
          isSubscriptionSelected();

        if (subscriptionSelected) {
          if (quantityInput) {
            quantityInput.value = '1';
          }

          if (quantityContainer) {
            quantityContainer.hidden =
              true;

            quantityContainer.style.display =
              'none';
          }

          buyRow?.classList.add(
            'fokus-pdp__buy-row--single'
          );
        } else {
          if (quantityContainer) {
            quantityContainer.hidden =
              false;

            quantityContainer.style.display =
              '';
          }

          buyRow?.classList.remove(
            'fokus-pdp__buy-row--single'
          );
        }

        const selectedPrice =
          getSelectedPurchasePrice();

        if (
          selectedPrice &&
          stickyPrice
        ) {
          stickyPrice.textContent =
            selectedPrice;
        }

        if (stickyLabel) {
          stickyLabel.textContent =
            subscriptionSelected
              ? 'Add subscription'
              : 'Add to cart';
        }

        synchronizeStickySummary();
      };

      const getPrimaryLabel = () => {
        return primaryLabel
          ?.textContent
          ?.trim();
      };

      const synchronizeButtons = () => {
        if (
          stickyButton &&
          primaryButton
        ) {
          stickyButton.disabled =
            primaryButton.disabled;
        }

        const label =
          getPrimaryLabel();

        if (
          label &&
          stickyLabel
        ) {
          stickyLabel.textContent =
            isSubscriptionSelected() &&
            label.toLowerCase() ===
              'add to cart'
              ? 'Add subscription'
              : label;
        }

        if (
          price &&
          stickyPrice
        ) {
          stickyPrice.textContent =
            getSelectedPurchasePrice() ||
            price.textContent.trim();
        }

        synchronizeStickySummary();
      };

      const setButtonState = (
        state
      ) => {
        if (!primaryButton) return;

        if (state === 'loading') {
          primaryButton.disabled =
            true;

          if (stickyButton) {
            stickyButton.disabled =
              true;
          }

          if (primaryLabel) {
            primaryLabel.textContent =
              'Adding…';
          }

          if (stickyLabel) {
            stickyLabel.textContent =
              'Adding…';
          }

          return;
        }

        if (state === 'added') {
          if (primaryLabel) {
            primaryLabel.textContent =
              'Added';
          }

          if (stickyLabel) {
            stickyLabel.textContent =
              'Added';
          }

          return;
        }

        primaryButton.disabled =
          false;

        if (stickyButton) {
          stickyButton.disabled =
            false;
        }

        if (primaryLabel) {
          primaryLabel.textContent =
            'Add to cart';
        }

        if (stickyLabel) {
          stickyLabel.textContent =
            isSubscriptionSelected()
              ? 'Add subscription'
              : 'Add to cart';
        }
      };

      purchaseTypeInputs.forEach(
        (input) => {
          input.addEventListener(
            'change',
            () => {
              synchronizePurchaseType();
            }
          );
        }
      );

      quantityMinus?.addEventListener(
        'click',
        () => {
          if (
            isSubscriptionSelected()
          ) {
            return;
          }

          updateQuantity(
            getQuantity() - 1
          );
        }
      );

      quantityPlus?.addEventListener(
        'click',
        () => {
          if (
            isSubscriptionSelected()
          ) {
            return;
          }

          updateQuantity(
            getQuantity() + 1
          );
        }
      );

      quantityInput?.addEventListener(
        'input',
        () => {
          if (
            isSubscriptionSelected()
          ) {
            quantityInput.value = '1';
          }

          synchronizeStickySummary();
        }
      );

      quantityInput?.addEventListener(
        'change',
        () => {
          quantityInput.value =
            String(getQuantity());

          synchronizeStickySummary();
        }
      );

      variantSelect?.addEventListener(
        'change',
        () => {
          const option =
            variantSelect
              .selectedOptions[0];

          if (!option) return;

          const optionPrice =
            option.dataset.price || '';

          if (price) {
            price.textContent =
              optionPrice;
          }

          if (stickyPrice) {
            stickyPrice.textContent =
              optionPrice;
          }

          const available =
            !option.disabled;

          if (primaryButton) {
            primaryButton.disabled =
              !available;
          }

          if (stickyButton) {
            stickyButton.disabled =
              !available;
          }

          const label = available
            ? 'Add to cart'
            : 'Sold out';

          if (primaryLabel) {
            primaryLabel.textContent =
              label;
          }

          if (stickyLabel) {
            stickyLabel.textContent =
              isSubscriptionSelected() &&
              available
                ? 'Add subscription'
                : label;
          }
        }
      );

      stickyButton?.addEventListener(
        'click',
        () => {
          if (
            primaryButton &&
            !primaryButton.disabled
          ) {
            primaryButton.click();
          }
        }
      );

      if (
        form &&
        primaryButton
      ) {
        form.addEventListener(
          'submit',
          async (event) => {
            event.preventDefault();

            if (
              primaryButton.disabled
            ) {
              return;
            }

            if (quantityInput) {
              quantityInput.value =
                String(getQuantity());
            }

            setButtonState('loading');

            if (error) {
              error.hidden = true;
              error.textContent = '';
            }

            try {
              const formData =
                new FormData(form);

              if (
                isSubscriptionSelected()
              ) {
                formData.set(
                  'quantity',
                  '1'
                );
              }

              const rootPath =
                window.Shopify?.routes
                  ?.root ||
                '/';

              const response =
                await fetch(
                  `${rootPath}cart/add.js`,
                  {
                    method: 'POST',
                    headers: {
                      Accept:
                        'application/json',
                      'X-Requested-With':
                        'XMLHttpRequest'
                    },
                    body: formData
                  }
                );

              const result =
                await response.json();

              if (!response.ok) {
                throw new Error(
                  result.description ||
                  result.message ||
                  'Unable to add this item.'
                );
              }

              setButtonState('added');

              document.dispatchEvent(
                new CustomEvent(
                  'fokus:cart:open',
                  {
                    bubbles: true,
                    detail: {
                      source:
                        'product-form',
                      product:
                        result,
                      quantity:
                        getQuantity(),
                      purchaseType:
                        getPurchaseType()
                    }
                  }
                )
              );

              document.dispatchEvent(
                new CustomEvent(
                  'cart:refresh',
                  {
                    bubbles: true
                  }
                )
              );

              window.setTimeout(
                () => {
                  setButtonState(
                    'default'
                  );
                },
                900
              );
            } catch (
              formError
            ) {
              if (error) {
                error.textContent =
                  formError.message;

                error.hidden = false;
              }

              setButtonState(
                'default'
              );
            }
          }
        );
      }

      dots.forEach((dot) => {
        dot.addEventListener(
          'click',
          () => {
            const index = Number(
              dot.dataset
                .fokusMediaDot ||
              0
            );

            media[index]
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
              });
          }
        );
      });

      if (
        track &&
        dots.length > 1
      ) {
        let ticking = false;

        track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;

            ticking = true;

            window.requestAnimationFrame(
              () => {
                const width =
                  Math.max(
                    1,
                    track.clientWidth
                  );

                const index =
                  Math.round(
                    track.scrollLeft /
                    width
                  );

                dots.forEach(
                  (
                    dot,
                    dotIndex
                  ) => {
                    const active =
                      dotIndex ===
                      index;

                    dot.classList.toggle(
                      'is-active',
                      active
                    );

                    dot.setAttribute(
                      'aria-current',
                      String(active)
                    );
                  }
                );

                ticking = false;
              }
            );
          },
          {
            passive: true
          }
        );
      }

      const desktopQuery =
        window.matchMedia(
          '(min-width: 990px)'
        );

      if (
        stickyBar &&
        primaryButton &&
        desktopQuery.matches
      ) {
        const observer =
          new IntersectionObserver(
            ([entry]) => {
              const showBar =
                !entry.isIntersecting &&
                window.scrollY > 200;

              stickyBar.classList.toggle(
                'is-visible',
                showBar
              );
            },
            {
              threshold: 0.05
            }
          );

        observer.observe(
          primaryButton
        );
      }

      synchronizePurchaseType();
      synchronizeButtons();
      synchronizeStickySummary();
    });
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeFokusProducts
    );
  } else {
    initializeFokusProducts();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeFokusProducts
  );
})();